import TableData from '../component/TableData';

const PlayersProfile = () => {
  const headerData = [
    '',
    'Name',
    'Email',
    'Phone Number',
    'City',
    'Credits',
    'User Status',
    'Suspended',
    // 'Verified',
  ];

  return (
    <>
      <TableData headerData={headerData} />
    </>
  );
};

export default PlayersProfile;
